var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getCountryISO2Cdes, getCountryNameForISO2 } from '../../utils/country.utils';
import { getIconForLanguage, getIconForNationality, getLocalizedLangLabel, ISO_LANGS } from '../../utils/translations.util';
// A fixed shortcut list for hotels in Austria/Germany, shared by every consumer. The rest of
// each ISO catalogue stays available under Other, sorted by the user's display language.
var COMMON_LANGUAGES = ['de', 'en', 'es', 'it', 'fr', 'nl', 'pl', 'cs', 'hu', 'sk', 'sl', 'hr', 'da', 'sv'];
var COMMON_COUNTRIES = ['at', 'de', 'ch', 'gb', 'es', 'it', 'fr', 'nl', 'be', 'pl', 'cz', 'hu', 'sk', 'si', 'hr', 'dk', 'se', 'li'];
export var countryLanguageOptions = function (kind, locale) {
    var common = kind === 'language' ? COMMON_LANGUAGES : COMMON_COUNTRIES;
    var countryNames = kind === 'country' ? new Intl.DisplayNames([locale], { type: 'region' }) : undefined;
    var entries = kind === 'language'
        ? ISO_LANGS.map(function (language) { return ({
            code: language.code,
            label: getLocalizedLangLabel(language.code, locale),
            englishName: language.name,
            nativeName: language.native,
            flag: getIconForLanguage(language.code),
        }); })
        : getCountryISO2Cdes().map(function (code) { return ({
            code: code,
            label: (countryNames === null || countryNames === void 0 ? void 0 : countryNames.of(code.toUpperCase())) || getCountryNameForISO2(code),
            englishName: getCountryNameForISO2(code),
            flag: getIconForNationality(code),
        }); });
    return entries.map(function (entry) { return (__assign(__assign({}, entry), { group: common.includes(entry.code) ? 'Common' : 'Other' })); }).sort(function (left, right) {
        var leftRank = common.indexOf(left.code);
        var rightRank = common.indexOf(right.code);
        if (leftRank !== -1 || rightRank !== -1) {
            return (leftRank === -1 ? common.length : leftRank) - (rightRank === -1 ? common.length : rightRank);
        }
        return left.label.localeCompare(right.label, locale);
    });
};
